export default __webpack_public_path__ + "static/media/storage.591fd93c.png";